'use client'

import { EcranErreur } from '@/components/ui'

/** Le filet de tous les autres espaces — formateur, pilotage, commercial. */
export default function ErreurApplication({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return <EcranErreur error={error} reset={reset} espace="l’application" />
}
